import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { SpinnerChangeEvent } from '../../models/spinner-change-event';
import { SpinnerService } from '../../services/spinner.service';

@Component({
    selector: 'osc-utils-spinner',
    templateUrl: './osc-spinner.component.html',
    standalone: false
})
export class OscSpinnerComponent implements OnInit, OnChanges {
  @Input() public small = false;
  @Input() public spinnerId: string = null;
  @Input() public spinnerClass: string = null;
  @Output() public readonly spinnerTimeout: EventEmitter<string> = new EventEmitter<string>();
  public progressMessageHeader = '';
  public progressMessage = '';
  public needProgressMessage = false;

  private _visible = false;
  private _timeout = 90000;
  private _failureMsg = '';

  private _timerCheck: ReturnType<typeof setTimeout>;

  public constructor(private spinnerService: SpinnerService) {
    this.spinnerService.spinnerChange.subscribe((event: SpinnerChangeEvent) => {
      if (this.spinnerId && this.spinnerId === event.spinnerId) {
        this._failureMsg = event.failureMsg ?? '';
        this._timeout = (event.timeoutInSec ?? 90) * 1000;
        this.visible = event.visible;
        this.needProgressMessage = event.needProgressMessage;
        this.progressMessageHeader = event.progressMessageHeader ?? 'Please wait...';
        this.progressMessage = event.progressMessage;
      }
    });
  }

  public get visible() {
    return this._visible;
  }

  public set visible(value: boolean) {
    this._visible = value;
    if (value) {
      this._timerCheck = setTimeout(() => {
        if (this._visible) {
          this.spinnerTimeout.emit(this._failureMsg);
          this._visible = false;
        }
      }, this._timeout);
    } else if (this._timerCheck) {
      clearInterval(this._timerCheck);
    }
  }

  public ngOnInit() {
    this.checkID();
  }

  public ngOnChanges() {
    this.checkID();
  }

  public getClasses(): Array<string> {
    const classes: Array<string> = new Array<string>();

    classes.push('osc-spinner');

    if (this.small) {
      classes.push('osc-spinner--small');
    }

    if (this.spinnerClass) {
      classes.push(this.spinnerClass);
    }

    return classes;
  }

  private checkID() {
    if (this.spinnerId === null) {
      throw new Error('SpinnerID is required');
    }
  }
}
